import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Signin from './components/login/signin.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'signin',
      component: Signin,
      meta: {
        checkAppSession: true
      }
    }
  ]
})


// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (!store.state.signedIn) {
//       next({ name: 'signin' })
//     } else {
//       next() // go to wherever I'm going
//     }
//   } else if (to.matched.some(record => record.meta.checkAppSession)) {
//     if (store.state.signedIn) {
//       next({ name: 'signin' })
//     } else {
//       next() // go to wherever I'm going
//     }
//   } else {
//     next() // does not require auth, make sure to always call next()!
//   }
// })

export default router
